import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 9DAFE242-BF4B-43F8-8A6E-89EBB0EEDCAA
 * name signal-off
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/signal-off.svg
 * tags
 * - Cellphone / Phone 
 */
export const SignalOffIcon = createSvgIcon(<><path d="M18,3V16.18L21,19.18V3H18M4.28,5L3,6.27L10.73,14H8V21H11V14.27L13,16.27V21H16V19.27L19.73,23L21,21.72L4.28,5M13,9V11.18L16,14.18V9H13M3,18V21H6V18H3Z" /></>, 'SignalOffIcon');
export default SignalOffIcon